import { Component, OnInit, Output } from "@angular/core";

import { ErrorStateMatcher } from "@angular/material/core";

import swal from "sweetalert2";

import { MatDialog } from "@angular/material";

import { Observable, interval } from "rxjs";

import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormGroupDirective,
  NgForm
} from "@angular/forms";
import { CustomValidators } from "../../utils/custom-validators";
import { WeAdminService } from "../../services/we-admin.service";
import { ModalUserInfoComponent } from "../../shared/components/modals/modal-user-info/modal-user-info.component";
import { WEUserAdmin } from "src/app/models/we-model";
import { InfoUtility } from "src/app/utils/info-utility";

import {
  trigger,
  transition,
  group,
  query,
  style,
  animate
} from "@angular/animations";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-documents",
  templateUrl: "./documents.component.html",
  styleUrls: ["./documents.component.scss"],
  providers: [CustomValidators, WeAdminService, InfoUtility],
  animations: [
    trigger("valueAnimation", [
      transition(
        ":increment",
        group([
          query(":enter", [
            style({ color: "blue", fontSize: "50px" }),
            animate("0.8s ease-out", style("*"))
          ])
        ])
      ),
      transition(
        ":decrement",
        group([
          query(":enter", [
            style({ color: "red", fontSize: "50px" }),
            animate("0.8s ease-out", style("*"))
          ])
        ])
      )
    ])
  ]
})
export class DocumentsComponent implements OnInit {
  // allNumbers: number[] = [1, 2, 3, 4, 5, 6];
  // selectedIndex = 0;

  // get banners() {
  //   return [this.allNumbers[0]];
  // }

  public hide: Boolean;
  public lottieConfig: Object;
  public searchUserFormGroup: FormGroup;
  public searchLoading: boolean = false;
  public notFound: boolean = false;

  public lastAdminCPF: string;

  public filterStatus: string = 'Todos';

  public usersArray: Array<any> = [];

  public globalSearch: boolean = true;

  public countUsers: number = 0;
  // public countAguardandoDocumento: number = 0;
  public countAguardandoAprovacao: number = 0;
  public countAprovado: number = 0;
  public countReprovado: number = 0;

  public lastUpdatedUser: any;


  constructor(
    public formBuilder: FormBuilder,
    public customValidator: CustomValidators,
    public weAdminService: WeAdminService,
    public dialog: MatDialog,
    public infoUtility: InfoUtility
  ) {
    this.setFormGroups();
  }
  

  ngOnInit() {
    this.lottieConfig = {
      path: "assets/animations/not_found.json",
      renderer: "canvas",
      autoplay: true,
      loop: true,
      
      

    };
    this.docUsers();
  }
  
  countAllStatus(){

    this.weAdminService.countAllStatus().subscribe(
      response => { 
        this.countAprovado = response.aprovados;
        this.countReprovado = response.reprovados;
        this.countAguardandoAprovacao = response.aguardandoaprovacao;
      }
    )
    return;
  }

  setFilterStatus(status: string) {
    this.filterStatus = status;
  }

  docUsers() {
    this.hide = false;
    this.searchLoading = true;
    this.globalSearch = true;



    // this.searchLoading = false;
    // this.usersArray = [{"idpessoa":"Bxncy9Mqwv9kP29AZEbdbLOQXGzm7BKw","idpessoa_tipo":"d0372e0b9a961104a08a191dd6f86900","email":"mozartsn@yahoo.com.br","nome":"Mozart Neto","cpf":"11867006707","rg":null,"rg_digito":null,"rg_uf":null,"telefone":null,"celular":null,"foto":null,"end_logradouro":null,"end_numero":null,"end_bairro":null,"end_complemento":null,"end_cep":null,"end_cidade":null,"end_pais":null,"end_estado":null,"sexo":"Não especificado","estado_civil":null,"gs_idestado_ativacao":"104","dt_nascimento":null,"matricula":null,"gs_dthr_primeira_adesao":"2019-11-06T19:46:50.831Z","complementar":null,"idpessoa_responsavel":null,"idade":18,"total_pontos":0,"idnivel":null,"hasAddress":false,"hasCelular":false,"hasContract":true,"login_externo":null,"cnhs":[{"idcnh":"14zwy4kjifz9xeti87vjgxknmp2jgw8i","alt_idusuario":null,"ins_idusuario":null,"idpessoa":"Bxncy9Mqwv9kP29AZEbdbLOQXGzm7BKw","nome":"Mozart Silva Neto","num_cnh":"03977394139","documento":"119924231DetranRJ","cpf":"11867006707","dt_nascimento":"1987-02-12T02:00:00.000Z","dt_validade":"2020-08-16T03:00:00.000Z","dt_pri_habilitacao":"2006-11-23T02:00:00.000Z","pontos_cnh":0,"ativo":true,"favorito":false,"obs":"teste","photo_url":"https://gs-mtc.s3.amazonaws.com/user-doc/14zwy4kjifz9xeti87vjgxknmp2jgw8i_2019-11-06T18:53:19+00:00.jpg"}],"renavans":[]},{"idpessoa":"DC9nROtSmfbXmA0axzfh8ITP4rUZI0VU","idpessoa_tipo":"d0372e0b9a961104a08a191dd6f86900","email":"vitor@portodave.com.br","nome":"Vitor Teste","cpf":"04298208796","rg":null,"rg_digito":null,"rg_uf":null,"telefone":null,"celular":null,"foto":null,"end_logradouro":null,"end_numero":null,"end_bairro":null,"end_complemento":null,"end_cep":null,"end_cidade":null,"end_pais":null,"end_estado":null,"sexo":"Não especificado","estado_civil":null,"gs_idestado_ativacao":"104","dt_nascimento":null,"matricula":null,"gs_dthr_primeira_adesao":"2019-09-04T13:13:11.934Z","complementar":null,"idpessoa_responsavel":null,"idade":18,"total_pontos":0,"idnivel":null,"hasAddress":false,"hasCelular":false,"hasContract":true,"login_externo":null,"cnhs":[{"idcnh":"67hf6t4fw4kaxr9izmuoux4bxgdr4sqa","alt_idusuario":null,"ins_idusuario":null,"idpessoa":"DC9nROtSmfbXmA0axzfh8ITP4rUZI0VU","nome":"VITOR SERRANO PORTO D AVE","num_cnh":"01063465487","documento":"122605017DetranRJ","cpf":"04298208796","dt_nascimento":"1981-10-09T03:00:00.000Z","dt_validade":"2019-12-31T03:00:00.000Z","dt_pri_habilitacao":"2000-12-01T02:00:00.000Z","pontos_cnh":0,"ativo":true,"favorito":false,"obs":"teste","photo_url":"https://gs-mtc.s3.amazonaws.com/user-doc/67hf6t4fw4kaxr9izmuoux4bxgdr4sqa_2019-10-09T11:28:53-03:00.jpg"}],"renavans":[{"idrenavam":"xkyvguqflt66n76fzmqixmrx06in6zid","alt_idusuario":null,"ins_idusuario":null,"idpessoa":"DC9nROtSmfbXmA0axzfh8ITP4rUZI0VU","idcontrato":null,"num_renavam":"1007382640","modelo":"BMW C600 SPORT","ano":"2014","vist":"2019-07-31T03:00:00.000Z","uf":"RJ","placa":"OXJ5311","status_renavam":"OK","ativo":true,"favorito":true,"obs":null,"photo_url":"https://gs-mtc.s3.amazonaws.com/user-doc/xkyvguqflt66n76fzmqixmrx06in6zid_2019-10-04T13:48:25-03:00.jpg"}]}]


    
    this.weAdminService.docUsers().subscribe(
      response => {
       
        this.searchLoading = false;
        if (!this.globalSearch && this.searchUserFormGroup.value) {
          this.lastAdminCPF = this.searchUserFormGroup.value;
        }
        this.usersArray = [];
        // this.countAprovado = response.aprovados;
        // this.countReprovado = response.reprovados;
        if (response.res) {
          this.usersArray = response.res;
        } else {
          this.notFound = true;
        }
        
      },
      err =>
        this.showAlert(
          "Erro de conexão",
          "Não foi possível realizar a operação",
          "error"
        )
    );
  }

  getApproved() {
    
    this.searchLoading = true;
    this.globalSearch = true;
    this.weAdminService.getApproved().subscribe(
      response => {
        this.countAllStatus();
        this.hide = true;
        if (!this.globalSearch && this.searchUserFormGroup.value) {
          this.lastAdminCPF = this.searchUserFormGroup.value;
        }
        this.usersArray = [];
        let users = response.dadosAprovados;
        this.applyRulesToUsersArray(users, false);
       
      },
      err =>
        this.showAlert(
          "Erro de conexão",
          "Não foi possível realizar a operação",
          "error"
        ),()=>{
          this.searchLoading = false;
          }

    );
    this.countAllStatus();
  }

  getDisapproved() {
    this.hide = true;
    this.countAllStatus();
    this.searchLoading = true;
    this.globalSearch = true;
    this.weAdminService.getDisapproved().subscribe(
      response => {
        this.searchLoading = false;
        if (!this.globalSearch && this.searchUserFormGroup.value) {
          this.lastAdminCPF = this.searchUserFormGroup.value;
        }
        this.usersArray = [];
        let users = response.dadosReprovados;
        this.applyRulesToUsersArray(users, false);
      },
      err =>
        this.showAlert(
          "Erro de conexão",
          "Não foi possível realizar a operação",
          "error"
        )
    );
    this.countAllStatus();
  }

  setFormGroups() {
    this.searchUserFormGroup = this.formBuilder.group({
      search: [
        "",
        Validators.compose([
          this.customValidator.CPFValidator,
          Validators.required
        ])
      ]
    });
  }

  checkCpf() {
    if (this.searchUserFormGroup.valid) {
      this.searchUser(this.searchUserFormGroup.value);
    } else {
      this.showAlert("CPF inválido", "Tente novamente", "error");
    }
  }

  searchUser(cpf: string) {
    this.searchLoading = true;
    this.notFound = false;
    this.globalSearch = false;
    this.weAdminService
      .postBuscarUsuario(this.searchUserFormGroup.value)
      .subscribe(
        response => {
          this.searchLoading = false;
          this.lastAdminCPF = this.searchUserFormGroup.value;
          this.usersArray = [];

          if (response.status == true) {
            var users = response.peopleFound;
            this.applyRulesToUsersArray(users, true);
          } else {
            this.notFound = true;
          }
        },
        err =>
          this.showAlert(
            "Erro de conexão",
            "Não foi possível realizar a operação",
            "error"
          )
      ),
      () => { };
      this.countAllStatus();
  }

  applyRulesToUsersArray(users, single: boolean) {
    // var countAguardandoDocumento: number = 0;
    var countAguardandoAprovacao: number = 0;    
   
    var lastUpdateInfo = {};

    if (!single) {
      this.countUsers = this.usersArray.length;
    }
   
    if(users){
      for (const key in users) {
        if (users.hasOwnProperty(key)) {
          const user = users[key];

         if( (user.status == 'Aprovado') || (user.status == 'Reprovado')  || (user.status == 'Aguardando Documento') ){
           this.hide = true;
         }

          var timestamp: number;
    
          // Check if user has document before push to array
          if (user.documento) {
            // Check if has single flag to block the count
            if (!single) {
    
    
              // if (users[i].status == "Aguardando Documento") {
        
                // countAguardandoDocumento++;
              // }
              if (user.status == "Aguardando Aprovação") {
        
                countAguardandoAprovacao++;
              }
              // Verify if user has date_update
              if (user.documento.date_update) {
                // Convert date to timestamp (user[i])
                var userIndexLastChange = this.infoUtility.getTimestampFormat(
                  user.documento.date_update
                );
    
                if (!timestamp) {
                  timestamp = userIndexLastChange;
                  lastUpdateInfo = {
                    responsible: user.documento.responsible,
                    date_update: user.documento.date_update
                  };
                } else {
                  if (timestamp < userIndexLastChange) {
                    timestamp = userIndexLastChange;
                    lastUpdateInfo = {
                      responsible: user.documento.responsible,
                      date_update: user.documento.date_update
                    };
                  }
                }
              }
            }
            // Check if user has pending documents and apply local rule to block user for any wrong request
            if (
              !user.documento.cpf.file &&
              !user.documento.identity.file ||
              !user.documento.residence.file ||
              user.documento.cpf.approved == "pending" &&
              user.documento.identity.approved == "pending" ||
              user.documento.residence.approved == "pending"
            ) {
              user.documento.aptoContrato = false;
            } else {
              user.documento.aptoContrato = true;
            }
    
            if (!single) {
              // this.countAguardandoDocumento = countAguardandoDocumento;
              this.countAguardandoAprovacao = countAguardandoAprovacao;
            }
    
            // LastUpdate
            this.lastUpdatedUser = lastUpdateInfo;
    
            // Push to Array
            this.usersArray.push(user);
          }
        }
      }

      // for (let i = 0; i < users.length; i++) {

      // }
    }

    if (this.usersArray.length == 0) {
      this.notFound = true;
    } else {
      this.notFound = false;
    }
  }

  showAlert(title, message, type) {
    this.searchLoading = false;
    swal({
      //
      buttonsStyling: false,
      animation: false,
      customClass: "app-swal animated zoomIn faster",
      confirmButtonClass: "primary-button",
      cancelButtonClass: "secundary-button",
      //
      title: title,
      text: message,
      type: type,
      confirmButtonText: "OK"
    });
  }

  openAuthModal(_users) {
    let dialogRef = this.dialog.open(ModalUserInfoComponent, {
      height: "100%",
      data: {
        users: _users
      },
      panelClass: "app-modal-user-info"
    });

    dialogRef.afterClosed().subscribe(
      response => { },
      error => {
        console.log(error);
      },
      () => { }
    );
  }

  submitApprovalEvent(data) {
    this.weAdminService.postAprovarDocumentos(data).subscribe(response => {
      this.reloadUsers();
    });
  }

  submitUserStatusEvent(data) {
    this.weAdminService.postInserirStatusAoUsuario(data).subscribe(
      response => {
        if (response.status == true) {
          this.showAlert("Sucesso", "Status modificado com sucesso", "success");
        } else {
          if (response.message) {
            this.showAlert("Erro", response.message, "error");
          }
        }
        this.reloadUsers();
      },
      err => {
        if (err.message) {
          this.showAlert("Erro", err.message, "error");
        } else {
          this.showAlert(
            "Erro",
            "Erro ao modificar status do usuário, verifique se o status do usuário novamente",
            "error"
          );
        }

        this.reloadUsers();
      }
    );
  }

  reloadUsers() {
    if (this.globalSearch) {
      this.docUsers();
    } else {
      this.searchUser(this.lastAdminCPF);
    }
  }
}
